import { IdenfyCheckResult } from '@tf/shared';
import { Alert, createStyles, Stack, TFText } from '@tf/ui';
import type React from 'react';

import type { DocumentCheck } from '../../../../../../api/documentCheck';

import { IdenfyResult } from './IdenfyResult';

const useStyles = createStyles(({ colors, radius }) => ({
	infoBlockWrapper: {
		width: '100%',
		padding: '.75rem .75rem',
		borderRadius: radius.sm,
		backgroundColor: colors.gray[1],
	},
	infoBlockContent: {
		display: 'block',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		marginRight: '.5rem',
		cursor: 'default',
		color: colors.brand[6],
	},
	clearSubStatusColor: {
		color: colors.green[8],
	},
	cautionSubStatusColor: {
		color: colors.yellow[7],
	},
	suspectedSubStatusColor: {
		color: colors.orange[7],
	},
	rejectedSubStatusColor: {
		color: colors.red[6],
	},
}));

const getJobResultMessage = (result: IdenfyCheckResult) => {
	switch (result) {
		case IdenfyCheckResult.APPROVED:
			return {
				status: 'APPROVED',
				text: 'There are no indications the document is fraudulent.',
				color: '#2F9E3F',
			};
		case IdenfyCheckResult.SUSPECTED:
			return {
				status: 'SUSPECTED',
				text: 'Document shows signs of suspect fraud.',
				color: '#FA5252',
			};
		case IdenfyCheckResult.DENIED:
			return {
				status: 'DENIED',
				text: "We can't process the document image, or the document isn't supported for processing.",
				color: '#FA5252',
			};
		default:
			return {
				status: 'UNIDENTIFIED',
				text: "We can't successfully complete all verifications.",
				color: '#344054',
			};
	}
};

interface Props {
	check: DocumentCheck;
}

export const Result: React.FC<Props> = ({ check }) => {
	const { classes } = useStyles();

	const idenfyStatus = check.data.response?.status?.overall;
	if (!idenfyStatus) {
		return null;
	}

	if (check.meta.service_kind === 'idenfy') {
		return (
			<Stack className={classes.infoBlockWrapper}>
				<Stack gap="xs">
					<TFText className={classes.infoBlockContent} fw={500}>
						Document check results:{' '}
						<span style={{ color: getJobResultMessage(idenfyStatus).color }}>
							{getJobResultMessage(idenfyStatus).status}
						</span>
					</TFText>
					<div style={{ color: getJobResultMessage(idenfyStatus).color }}>{getJobResultMessage(idenfyStatus).text}</div>
				</Stack>
				<IdenfyResult check={check} />
			</Stack>
		);
	}

	return (
		<Alert w="100%" color="red">
			Unknown service provider
		</Alert>
	);
};
